function createGeoJSONTemplate(geometry) {
    return {
        "type": "FeatureCollection",
        "features": [
            {
                "type": "Feature",
                "properties": {},
                "geometry": geometry
            }
        ]
    };
}

module.exports = createGeoJSONTemplate;